<template>
  <!-- images for the first slidesPerView slides -->
  <div class="image" v-on="$listeners" v-if="index < slidesPerView">
    <images :image="image" :alt="alt" :width="width" :height="height"/>
  </div>
  <!-- lazy loading of images after the first slidesPerView slides -->
  <div class="image" v-on="$listeners" v-else>
    <images-lazy-load :image="image" :alt="alt" :width="width" :height="height"/>
  </div>
</template>

<script>
import Images from "./Images";
import ImagesLazyLoad from "./ImagesLazyLoad";

export default {
  components: {
    Images,
    ImagesLazyLoad
  },
  props: {
    image: {
      type: Object,
      default: () => ({
        src: '',
        loading: ''
      })
    },
    alt: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 163
    },
    height: {
      type: Number,
      default: 163
    },
    index: {
      type: Number,
      default: 0
    },
    slidesPerView: {
      type: Number,
      default: 4
    }
  }
}
</script>

<style lang="scss" scoped>
  .image {
    padding-bottom: 0!important;
    div {
      position: relative;
      width: 100%;
      height: 150px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      padding-bottom: 0 !important;
    }
  }
</style>
